module.exports = __webpack_public_path__ + "img/grey.fced3f5f.jpg";